import FilterForm from 'assets/components/filters/filterForm/FilterForm';
import ThemeFilterFormDrawer from 'assets/components/filters/filterForm/themes/Theme.FilterForm.Drawer';
import { useProductEnhancementProvider } from '../ProductEnhancement.Hooks';

export default function ProductEnhancementFilters() {
  const { listApi } = useProductEnhancementProvider();

  return (
    <FilterForm
      subcomponents={ThemeFilterFormDrawer}
      search={listApi.body?.search}
      onSearch={(search) => listApi.execute((body) => ({ ...body, search }))}
      filters={listApi?.body}
      onFilter={(newFilers) => listApi?.execute(newFilers)}
      onReset={listApi?.reset}
    />
  );
}
